export const environment = {
  production: false,
  apiUrl: 'https://staging.[nombreproyecto].api.innovaweb.cl/api',
};
